import { alpha } from '@mui/material/styles';
import { mobileAppGlassCard } from '../components/layout/mobile/mobileAppTheme';
import { LOGIN_ACCENT } from '../components/auth/loginDarkTheme';

export const HOTEL_PICKER_ACCENT = LOGIN_ACCENT;

export function getMobileHotelPickerSheetPaperSx() {
  return {
    ...mobileAppGlassCard,
    borderRadius: '22px 22px 0 0',
    borderBottom: 'none',
    background:
      'linear-gradient(165deg, rgba(6, 10, 22, 0.98) 0%, rgba(3, 7, 18, 0.99) 55%, rgba(5, 14, 12, 0.96) 100%)',
    boxShadow: '0 -24px 48px rgba(0,0,0,0.55), inset 0 1px 0 rgba(255,255,255,0.07)',
    maxHeight: 'min(78vh, 560px)',
    overflow: 'hidden',
  };
}

export function getMobileHotelPickerBackdropSx() {
  return {
    backgroundColor: 'rgba(2, 6, 14, 0.62)',
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)',
  };
}

export function getMobileHotelPickerHandleSx() {
  return {
    width: 42,
    height: 4,
    borderRadius: 999,
    bgcolor: alpha('#ffffff', 0.18),
    mx: 'auto',
    mt: 1.1,
    mb: 0.35,
  };
}

export function getMobileHotelPickerHeaderSx() {
  return {
    px: 2,
    pt: 0.75,
    pb: 1.25,
    borderBottom: `1px solid ${alpha('#ffffff', 0.08)}`,
  };
}

export function getMobileHotelPickerTitleSx() {
  return {
    color: '#f8fafc',
    fontWeight: 800,
    fontSize: '1.05rem',
    letterSpacing: '-0.02em',
    lineHeight: 1.2,
  };
}

export function getMobileHotelPickerSubtitleSx() {
  return {
    color: alpha('#94a3b8', 0.95),
    fontSize: '0.78rem',
    mt: 0.35,
    lineHeight: 1.35,
  };
}

export function getMobileHotelPickerListSx() {
  return {
    px: 1.5,
    py: 1.25,
    overflowY: 'auto',
    maxHeight: 'calc(min(78vh, 560px) - 96px)',
    display: 'flex',
    flexDirection: 'column',
    gap: 0.75,
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': { display: 'none' },
  };
}

export function getMobileHotelPickerItemSx(isSelected, accent = HOTEL_PICKER_ACCENT) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: 1.1,
    width: '100%',
    p: 1.15,
    borderRadius: '16px',
    cursor: 'pointer',
    textAlign: 'left',
    border: isSelected
      ? `1px solid ${alpha(accent, 0.45)}`
      : `1px solid ${alpha('#ffffff', 0.08)}`,
    background: isSelected
      ? `linear-gradient(145deg, ${alpha(accent, 0.22)} 0%, ${alpha(accent, 0.06)} 100%)`
      : `linear-gradient(155deg, ${alpha('#ffffff', 0.04)} 0%, ${alpha('#000000', 0.22)} 100%)`,
    boxShadow: isSelected
      ? `0 10px 24px ${alpha(accent, 0.14)}, inset 0 1px 0 ${alpha('#ffffff', 0.06)}`
      : `inset 0 1px 0 ${alpha('#ffffff', 0.04)}`,
    transition: 'border-color 0.15s ease, background 0.15s ease, transform 0.12s ease',
    '&:active': {
      transform: 'scale(0.985)',
    },
  };
}

export function getMobileHotelPickerIconSx(isSelected, accent = HOTEL_PICKER_ACCENT) {
  return {
    width: 42,
    height: 42,
    borderRadius: '13px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    background: isSelected
      ? `linear-gradient(145deg, ${alpha(accent, 0.38)} 0%, ${alpha(accent, 0.12)} 100%)`
      : `linear-gradient(145deg, ${alpha('#64748b', 0.22)} 0%, ${alpha('#000000', 0.18)} 100%)`,
    border: isSelected
      ? `1px solid ${alpha(accent, 0.35)}`
      : `1px solid ${alpha('#ffffff', 0.08)}`,
    color: isSelected ? accent : alpha('#cbd5e1', 0.85),
    boxShadow: isSelected ? `0 8px 18px ${alpha(accent, 0.18)}` : 'none',
  };
}

export function getMobileHotelPickerNameSx(isSelected) {
  return {
    color: isSelected ? '#f8fafc' : '#e2e8f0',
    fontWeight: isSelected ? 800 : 600,
    fontSize: '0.92rem',
    lineHeight: 1.25,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  };
}

export function getMobileHotelPickerMetaSx() {
  return {
    color: alpha('#94a3b8', 0.95),
    fontSize: '0.72rem',
    lineHeight: 1.3,
    mt: 0.2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  };
}

export function getMobileHotelPickerCheckSx(accent = HOTEL_PICKER_ACCENT) {
  return {
    width: 28,
    height: 28,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    bgcolor: alpha(accent, 0.16),
    border: `1px solid ${alpha(accent, 0.35)}`,
    color: accent,
  };
}

export function getMobileHotelPickerTriggerSx(isOpen) {
  return {
    ...mobileAppGlassCard,
    p: 1.05,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    borderRadius: '14px',
    borderColor: isOpen ? alpha(HOTEL_PICKER_ACCENT, 0.35) : 'rgba(255, 255, 255, 0.09)',
    boxShadow: isOpen
      ? `0 12px 24px rgba(0,0,0,0.38), inset 0 1px 0 rgba(255,255,255,0.06), 0 0 0 1px ${alpha(HOTEL_PICKER_ACCENT, 0.12)}`
      : undefined,
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
  };
}

export function getMobileHotelPickerTriggerIconSx() {
  return {
    width: 34,
    height: 34,
    borderRadius: '11px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    mr: 1,
    background: `linear-gradient(145deg, ${alpha(HOTEL_PICKER_ACCENT, 0.32)} 0%, ${alpha(HOTEL_PICKER_ACCENT, 0.1)} 100%)`,
    border: `1px solid ${alpha(HOTEL_PICKER_ACCENT, 0.28)}`,
    color: HOTEL_PICKER_ACCENT,
  };
}

export function getMobileHotelPickerEmptySx() {
  return {
    py: 3,
    px: 2,
    textAlign: 'center',
    color: alpha('#94a3b8', 0.95),
    fontSize: '0.85rem',
  };
}
